import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  background-color: #f9f6ef;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 55px 42px 32px 42px;
  width: 100%;
  text-align: center;

  @media (min-width: ${props => props.theme.mediaQuery.smallpc}) {
    padding: 40px 0 40px 0;
  }
`

export const Title = styled.span<{ textColor?: string }>`
  h2{
    color: ${props => props.textColor ?? '#000'} !important;
  }

  @media (min-width: ${props => props.theme.mediaQuery.smallpc}) {
    width: 741px;
  }
`
